export const SET_USER_DASHBOARDS_LOADED = "SET_USER_DASHBOARDS_LOADED";

export const setUserDashboardsLoaded = (userDashboardsLoaded: boolean) => {
  return {
    userDashboardsLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_DASHBOARDS_LOADED
  };
};
